import React from 'react';
import ReactsCard from "../components/ui/ReactsCard";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {DistributeSubscriptions} from "../components/subscriptions-distribution/DistributeSubscriptions";
import {Navigate, useParams} from "react-router-dom";
import {WithOrganization} from "../components/organizations/organization-context";

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
        justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    }
}));
export const DistributeSubscriptionsView: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {organizationUnitId} = useParams<{organizationUnitId: string}>()
    const {t} = useTranslation();

    if (!organizationUnitId || isNaN(+organizationUnitId)) {
        return <Navigate to='/organization-units' replace={false}/>;
    }

    return (
        <ReactsCard title={t('Subscription.DistributeSubscriptions.Title')} className={classes.root}>
            <DistributeSubscriptions firstSourceOrgUnitId={organizationUnitId}/>
        </ReactsCard>
    )
};
